import _map from 'lodash/map';
import { Player } from 'shaka-player';

function getCredentialParamsString(partCredentials) {
  return `${_map(Object.keys(partCredentials), paramKey => {
    return `${paramKey}=${window.encodeURIComponent(
      partCredentials[paramKey]
    )}`;
  }).join('&')}`;
}

export const getDashPlaylistWithCredentials = (
  playlistUrl,
  partCredentials
) => {
  return playlistUrl.replace(
    /.mpd/,
    `.mpd?${getCredentialParamsString(partCredentials)}`
  );
};

/**
 * Setup the DASH player into the <video> element provided
 *
 * @param {Object} attr - Attributes
 * @param {string} attr.manifestUrl
 * @param {HTMLVideoElement} attr.videoElement
 * @param {object} attr.partCredentials
 * @param {(el: HTMLVideoElement) => void=} attr.beforeLoad
 * @param {(error: Error) => void=} attr.onLoadError
 *
 * @returns {Player}
 */
export function createDashInstance({
  manifestUrl,
  videoElement,
  partCredentials,
  beforeLoad = () => {},
  onLoadError = () => {},
}) {
  const player = new Player(videoElement);
  const queryParameters = `?${getCredentialParamsString(partCredentials)}`;

  player.configure({
    streaming: {
      bufferingGoal: 120, // arbitrary
    },
  });

  // Intercept requests to segments and append the query parameters to authorize the request.
  player.getNetworkingEngine().registerRequestFilter((type, request) => {
    request.uris[0] = (request.uris[0] + queryParameters).replace(/\?+/, '?'); // // replace a sequence of ? with a single char
  });

  beforeLoad(player);

  // remove credentials from URL, if any, before loading the player.
  // The new ones will be applied by shaka-player thanks to callback passed
  // to registerRequestFilter.
  player
    .load(removeQueryParams(manifestUrl, Object.keys(partCredentials)))
    .catch(onLoadError);

  return player;

  function removeQueryParams(url, params) {
    let newUrl = url;

    params.forEach(key => {
      newUrl = newUrl.replace(new RegExp(`${key}=(.*)?&?`, 'g'), '');
    });

    return newUrl;
  }
}

export function isDashSupported() {
  return isWebmSupported();
}

export function isWebmSupported() {
  // safari 14 supports MSE but not dash
  const isNotSafari = !window.safari;

  return (
    isNotSafari &&
    typeof (window.MediaSource || window.WebKitMediaSource) === 'function'
  );
}
